import React,{useState,useCallback,useEffect} from 'react';
import {useDispatch,useSelector} from "react-redux";
import styled from 'styled-components';
import {saveNotification} from '../reducks/Img/operations';
import { getUsername } from '../reducks/users/selectors';
import {SelectInput,ImageArea,SignInput,PrimaryButton,TextArea} from '../components/UIkit';

const ButtonArea= styled.div`
 margin-top: 3em;
`;

const Title= styled.h3`
 font-size: 1.5em;
 font-weight: bold;
`;

const Text= styled.p`
text-align:center;
padding-top:1.5em;
`;

const Top= styled.div`
  margin-top: 10em;
`;

const ImagePost = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const username = getUsername(selector);

  const [title, setTitle] = useState(""),
        [description, setDescription] = useState(""),
        [images, setImages] = useState(""),
        [old, setOld] = useState(""),
        [name, setName] = useState(username),
        [coupling, setCoupling] = useState("");

        const inputName = useCallback((event) => {
          setName(event.target.value)
        },[setName]);

const inputTitle = useCallback((event) => {
  setTitle(event.target.value)
},[setTitle]);

const inputDescription = useCallback((event) => {
  setDescription(event.target.value)
},[setDescription]);

const olds =  [
  {id: "select1", name: '選択してください'},
  {id: "年齢指定なし", name: '年齢指定なし'},
  {id: "R18", name: 'R18'},
  {id: "R18G", name: 'R18G'}
];

const couplings =  [
  {id: "select2", name: '選択してください'},
  {id: "カップリングなし", name: 'カップリングなし'},
  {id: "guraギガ", name: 'Guraギガ'},
  {id: "ギガGura", name: 'ギガGura'}
];
   
 return(

<div className="common__contents">
    <div className="common__size">
    <Top>

      <Title>イラスト・漫画の投稿</Title>
      <Text>複数枚の画像を投稿することができます。</Text>

<SignInput
      label={"作品タイトル"}
      placeholder={"記入してください"}
      type={"text"}
      required={true}
      name={"title"}
      id={"title"}
      className={"title"}
      autocomplete={"off"}
      value={title}
      onChange={inputTitle}
     />

<ImageArea images={images} setImages={setImages} />

      <TextArea
      label={"作品詳細"}
      placeholder={"入力してください"}
      type={"text"}
      required={true}
      name={"description"}
      id={"description"}
      className={"description"}
      autocomplete={"off"}
      value={description}
      onChange={inputDescription}
     />  

<SignInput
      label={"投稿者名"}
      placeholder={"入力してください"}
      type={"text"}
      required={true}
      name={"name"}
      id={"name"}
      className={"name"}
      autocomplete={"off"}
      value={name}
      onChange={inputName}
     />  

<SelectInput
     name={"old"}
     id={"old"}
     label={"年齢制限"}
     options={olds}
     select={setOld}
     value={old}
     />

<SelectInput
     name={"coupling"}
     id={"coupling"}
     label={"カップリング"}
     options={couplings}
     select={setCoupling}
     value={coupling}
     />

<ButtonArea>
<PrimaryButton
label={"作品を投稿する"}
onClick={() => dispatch(saveNotification({
    title:title,
    old: old,
    coupling: coupling,
    images: images,
    description: description,
    name:name
    }))}
/>

</ButtonArea>
</Top>
</div>
</div>
 )
}

export default ImagePost;